import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { HeaderButtons, HeaderItem } from '../components/HeaderButtons';
import { Heading } from '../components/Text';
import { View } from '../components/View';
import { useTheme } from '../styles';

export function TabHeader({
  heading,
  headerRight,
  borderBottom,
}: {
  heading: string;
  headerRight?: React.ReactNode;
  borderBottom?: boolean;
}) {
  const { theme } = useTheme();
  const insets = useSafeAreaInsets();
  return (
    <View style={{ paddingTop: insets.top }}>
      <View
        row
        style={[
          { paddingTop: 30, justifyContent: 'space-between', paddingBottom: 10 },
          borderBottom ? { borderBottomWidth: 1, borderColor: theme.color.gray600 } : null,
        ]}
      >
        {headerRight ? (
          <HeaderButtons>
            <View aria-hidden pointerEvents="none" style={{ opacity: 0 }}>
              <HeaderItem
                aria-label={undefined}
                iconName="edit"
                title=""
                onPress={() => {}}
                style={{ opacity: 0 }}
                disabled // opacity is controlled by HeaderItem if the item is not disabled
                color={theme.color.gray500}
              />
            </View>
          </HeaderButtons>
        ) : (
          <View />
        )}
        <Heading text={heading} style={{ zIndex: 2 }} level={1} textAlign="center" />
        {headerRight ? <HeaderButtons>{headerRight}</HeaderButtons> : <View />}
      </View>
    </View>
  );
}
